<template>
  <div class="lp-dialog" v-if="value.show">
    <div class="lp-dialog-container">
      <span class="close" @click="close" v-if="value.close"><img src="/img/ui/close_gray.png" alt=""></span>
      <div class="head" v-if="value.title">
        {{ value.title }}
      </div>
      <div class="body">
        <slot name="body">
        </slot>
      </div>
      <slot class="body" v-if="!value.content"></slot>
      <div class="body" v-else v-html="value.content"></div>
      <div class="foot">
        <slot name="foot">
          <a class="lp-btn large primary submit-btn" @click="close">{{ value.cancelBtn || '取消' }}</a>
        </slot>
      </div>
    </div>
    <div class="mask" @click="close(value.maskClose)"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: {
        content: false,
        show: false,
        cancelBtn: '取消',
        maskClose: true,
        close: true
      }
    }
  },
  methods: {
    close (maskClose) {
      if (!maskClose) return
      console.log('环保')
      this.value.show = false
      this.$emit('input', this.value)
    }
  }
}
</script>

<style lang="stylus">
.lp-dialog
  position fixed
  left 0
  top 0
  right 0
  bottom 0
  z-index 999
  .mask
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    background rgba(0, 0, 0, 0.5)
    z-index 1000
  .lp-dialog-container
    position absolute
    min-height 4rem
    min-width 6rem
    background #fff
    box-sizing border-box
    padding 0.35rem 0
    clear both
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    border-radius 0.1rem
    -moz-border-radius 0.1rem
    -ms-border-radius 0.1rem
    -webkit-border-radius 0.1rem
    -o-border-radius 0.1rem
    word-break break-all
    z-index 10020
    .head
      position relative
      font-size 0.36rem
      text-align center
      padding 0.15rem
    span.close
      position absolute
      right 0.4rem
      top 0.4rem
      opacity 1
      z-index 10030
      img
        width 0.3rem
        object-fit cover
    .body
      padding 0.1rem 0.6rem 0.1rem
      font-size 0.2rem
    .foot
      display flex
      justify-content center
      align-items center
      padding 0.15rem
      a
        width 2.8rem
        height 0.72rem
        line-height 0.72rem
        font-size 0.3rem
        margin 0 0.15rem
        color gray
        text-align center
        background-color #3b6ae0
        border-radius 0.1rem
        border-color #3b6ae0
        border-width 1px
        border-style solid
        &.primary
          background #3b6ae0
          color #fff
          &:active
            background #2e5bcc
        &.defaults
          background #fff
          border-color #e6e6e6
        &.submit-btn
          color #fff
@media screen and (orientation portrait)
  .lp-dialog
    .lp-dialog-container
      width 80%
</style>
